import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import DefaulterCheckRow from "./DefaulterCheckRow";

const DefaulterCheckTable = ({ defaulterData }) => {
  const { _t } = useTranslator();

  return (
    <>
      <div className="upcoming-box overflow-auto">
        <table className="upcoming-table landlord-table bigtable_set">
          <thead>
            <tr className="first-row">
              <th>{_t("tipoDeAcreedor", "Field in defaulter check table")} </th>
              <th> {_t("producto", "Field in defaulter check table")} </th>
              <th>
                {_t(
                  "importeDeLasOperaciones",
                  "Field in defaulter check table"
                )}
              </th>
              <th> {_t("situación", "Field in defaulter check table")} </th>
              <th> {_t("noDeImpagados", "Field in defaulter check table")} </th>
              <th>
                {_t("importeImpagados", "Field in defaulter check table")}{" "}
              </th>
              <th>
                {_t("fechaPrimerImpago", "Field in defaulter check table")}{" "}
              </th>
              <th>
                {_t("fechaUltimoImpago", "Field in defaulter check table")}{" "}
              </th>
            </tr>
          </thead>

          <tbody>
            {haveValue(defaulterData)
              ? defaulterData.map((data) => <DefaulterCheckRow data={data} />)
              : _t("noDataFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default DefaulterCheckTable;
